var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgForsideMenuikon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_798",
    "data-name": "Group 798",
    transform: "translate(-43 -133.929)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_330",
    "data-name": "Rectangle 330",
    transform: "translate(43 133.929)",
    fill: "none",
    stroke: "#112f4a",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 6,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 16.5,
    height: 4.5,
    rx: 0.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_331",
    "data-name": "Rectangle 331",
    transform: "translate(43 140.929)",
    fill: "none",
    stroke: "#112f4a",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 4,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 6.5,
    height: 2.5,
    rx: 0.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_333",
    "data-name": "Rectangle 333",
    transform: "translate(43 145.929)",
    fill: "none",
    stroke: "#112f4a",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 4,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 6.5,
    height: 2.5,
    rx: 0.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_332",
    "data-name": "Rectangle 332",
    transform: "translate(52 140.929)",
    fill: "none",
    stroke: "#112f4a",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 7.5,
    height: 7.5,
    rx: 0.25,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForsideMenuikon);
export default __webpack_public_path__ + "static/media/Forside_menuikon.1bef773388646f94a41de11ba898d5de.svg";
export { ForwardRef as ReactComponent };